export default (state = null, action) => {
    switch (action.type) {
        default:
            return state;
    }

};



// WEBPACK FOOTER //
// ./src/app/profile/reducers/ProfileReducer.js